import { useClickListener } from 'lib/events-framework/useClickListener'
import React, { FC, memo, useCallback, useContext, useRef } from 'react'
import styled from 'styled-components'

import { sliderContext } from './index'

type Props = {
  slideWidth?: number
  onClick?: (e: MouseEvent) => void
}

export const Slide: FC<Props> = ({ children, slideWidth, onClick }) => {
  const emptyOnClick = useCallback(() => {}, [])
  if (!onClick) onClick = emptyOnClick
  const slideRef = useRef(null)
  const { isMoving } = useContext(sliderContext)
  useClickListener(slideRef, onClick)

  return (
    <StyledSlide slideWidth={slideWidth} ref={slideRef} isMoving={isMoving}>
      {children}
    </StyledSlide>
  )
}

const StyledSlide = styled.div<{ slideWidth?: number; isMoving: boolean }>`
  flex-shrink: 0;
  pointer-events: ${(props) => (props.isMoving ? 'none' : 'initial')};
  width: ${({ slideWidth }) => (slideWidth ? `${slideWidth}px` : '100%')};
  user-select: none;
`
